import { render, staticRenderFns } from "./WardExam.vue?vue&type=template&id=8b78e986&"
import script from "./WardExam.vue?vue&type=script&lang=ts&"
export * from "./WardExam.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b78e986')) {
      api.createRecord('8b78e986', component.options)
    } else {
      api.reload('8b78e986', component.options)
    }
    module.hot.accept("./WardExam.vue?vue&type=template&id=8b78e986&", function () {
      api.rerender('8b78e986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/WardExam.vue"
export default component.exports